import AxiosInstance from "../services/networkServices";

export const previewUserModification = async (username) => {
  const response = await AxiosInstance.post("/admin/user-modification/preview", {
    username,
  });
  return response.data;
};

export const adjustUserVisibleRank = async (payload) => {
  const response = await AxiosInstance.post(
    "/admin/user-modification/adjust-lp",
    payload,
  );
  return response.data;
};

export const setStaffStatus = async ({ username, isStaff }) => {
  const response = await AxiosInstance.post(
    "/admin/user-modification/staff-status",
    { username, isStaff },
  );
  return response.data;
};

export const revertMatchLp = async (payload) => {
  const response = await AxiosInstance.post(
    "/admin/user-modification/revert-match-lp",
    payload,
  );
  return response.data;
};

export const undoRevertMatchLp = async (payload) => {
  const response = await AxiosInstance.post(
    "/admin/user-modification/undo-revert-match-lp",
    payload,
  );
  return response.data;
};

export const getUserPagentHistory = async ({ username, page = 1, limit = 20 }) => {
  const response = await AxiosInstance.post(
    "/admin/user-modification/pagent-history",
    { username, page, limit },
  );
  return response.data;
};

export const getUserModificationPosts = async ({
  username,
  page = 1,
  limit = 20,
  includeDeleted = false,
}) => {
  const response = await AxiosInstance.post("/admin/user-modification/posts", {
    username,
    page,
    limit,
    includeDeleted,
  });
  return response.data;
};

export const createTempPassword = async (username) => {
  const response = await AxiosInstance.post(
    "/admin/user-modification/temp-password",
    { username },
  );
  return response.data;
};
